import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useHeightFilter = (talentFilter, talentFilterTags) => {
  const [minFeet, setMinFeet] = useState("");
  const [minInches, setMinInches] = useState("");
  const [maxFeet, setMaxFeet] = useState("");
  const [maxInches, setMaxInches] = useState("");

  // hydrate from existing filter
  useEffect(() => {
    const attr = talentFilter?.person_attributes?.find(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.height
    );

    if (!attr) return;

    setMinFeet(Math.floor(attr.start_value / 12));
    setMinInches(attr.start_value % 12);
    setMaxFeet(Math.floor(attr.end_value / 12));
    setMaxInches(attr.end_value % 12);
  }, []);

  useEffect(() => {
    const exists = talentFilter?.person_attributes?.some(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.height
    );

    if (!exists) {
      clearHeight();
    }
  }, [talentFilter]);

  const clearHeight = () => {
    setMinFeet("");
    setMinInches("");
    setMaxFeet("");
    setMaxInches("");
  };

  const minValue = parseInt(minFeet || 0) * 12 + parseInt(minInches || 0);
  const maxValue = parseInt(maxFeet || 0) * 12 + parseInt(maxInches || 0);

  const isDisabled =
    !minFeet ||
    !maxFeet ||
    minValue <= 0 ||
    maxValue <= minValue;

  const buildHeightFilter = () => {
    if (isDisabled) return null;

    const heightAttribute = {
      person_attribute_uuid: uuidMapping.height,
      contains: false,
      has_all_in_list: false,
      list: null,
      start_value: minValue,
      end_value: maxValue,
    };

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.height,
      {
        start_value: `${minFeet}'${minInches}"`,
        end_value: `${maxFeet}'${maxInches}"`,
      }
    );

    return { attribute: heightAttribute, tags };
  };

  return {
    minFeet,
    minInches,
    maxFeet,
    maxInches,
    setMinFeet,
    setMinInches,
    setMaxFeet,
    setMaxInches,
    isDisabled,
    buildHeightFilter,
    clearHeight
  };
};
